module.exports = __webpack_public_path__ + "static/media/woman-in-blue-bra.ed30ffbd.jpg";